export const cookieToken = 'token-taxt_v2';
export const cookieRefresh = 'refresh-taxt_v2';
export const cookieQuestionaire = 'taxt-questionaire-v2';
